import { useEffect, useState } from 'react';
import { Check, Home as HomeIcon } from 'lucide-react';
import { useApp } from '../lib/AppContext';
import Button from '../components/Button';
import Logo from '../assets/Untitled design (1).svg';

export default function SubmissionSuccess() {
  const { navigateTo } = useApp();
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    setShowConfetti(true);
    const timer = setTimeout(() => setShowConfetti(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-[#111111] flex items-center justify-center px-6" style={{ paddingBottom: 'calc(92px + env(safe-area-inset-bottom, 0px) + 16px)' }}>
      {showConfetti && <ConfettiEffect />}

      <div className="w-full max-w-md text-center">
        <div className="relative mb-8">
          <div className="absolute inset-0 opacity-20">
            <div className="absolute inset-0 bg-gradient-to-br from-[#40E0D0]/30 via-transparent to-[#FF6F61]/30 animate-pulse" />
          </div>

          <div className="relative w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-[#40E0D0] to-[#40E0D0] rounded-full flex items-center justify-center animate-scale-in shadow-2xl shadow-[#40E0D0]/30">
            <Check size={48} className="text-black" strokeWidth={3} />
          </div>
        </div>

        <h1 className="text-4xl font-bold text-white mb-4">
          Thanks for the recommendation!
        </h1>

        <p className="text-[17px] text-gray-300 leading-relaxed mb-12 max-w-sm mx-auto">
          We'll review your suggestion as we build the civicbeat collection.
        </p>

        <Button
          variant="secondary"
          onClick={() => navigateTo('contribute')}
          fullWidth
          className="flex items-center justify-center gap-2 mb-3"
        >
          <HomeIcon className="w-5 h-5" />
          Back to Contribute
        </Button>

        <button
          onClick={() => navigateTo('home')}
          className="text-[#40E0D0] text-sm underline"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}

function ConfettiEffect() {
  const confettiPieces = Array.from({ length: 50 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 0.5,
    duration: 2 + Math.random() * 1,
    color: ['#40E0D0', '#FF6F61', '#FFD700', '#87CEEB'][Math.floor(Math.random() * 4)],
  }));

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {confettiPieces.map((piece) => (
        <div
          key={piece.id}
          className="absolute w-2 h-2 rounded-full animate-confetti"
          style={{
            left: `${piece.left}%`,
            top: '-10px',
            backgroundColor: piece.color,
            animationDelay: `${piece.delay}s`,
            animationDuration: `${piece.duration}s`,
          }}
        />
      ))}
    </div>
  );
}
